import { render } from "./Main.vue?vue&type=template&id=2dcbab52"
const script = {}
script.render = render

export default script